import { styled } from '@linaria/react';
import { animated } from 'react-spring';

import {
  LIGHT_COLORS_RAW,
  DARK_COLORS_RAW,
} from '@/constants/colors';

export const SPRING_CONFIGS = [
  {
    tension: 170,
    friction: 60,
  },
];

export const BaseWrapper = styled.button`
  position: relative;
  width: 243px;
  max-width: 65%;
  height: 460px;
  margin: 64px auto 48px auto;
  border: 2px solid transparent;
  isolation: isolate;

  /*
  The outline looks funky AF since there are so many random
  elements. Instead let's use a border.
*/
  &:focus {
    outline: none;
    border-color: var(--color-primary);
    border-radius: 4px;
  }
`;

export const Layer = styled(animated.div)`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  will-change: transform;
`;

export const Skew = styled.div`
  transform: skewY(18deg);
  overflow: hidden;
`;

export const BaseElement = styled.div`
  position: relative;
  width: 100%;
  height: 175px;
  border: 4px solid var(--color-text);
  border-radius: 2px;
  background: var(--color-background);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const [wh, ws, wl] = LIGHT_COLORS_RAW.colorBackground;
const [dh, ds, dl] = DARK_COLORS_RAW.colorBackground;

export const ChildElement = styled(BaseElement)`
  background: hsl(${wh}deg ${ws}% ${wl}% / 0.5);

  html[data-color-mode='dark'] & {
    background: hsl(${dh}deg ${ds}% ${dl}% / 0.5);
  }
`;

export const BaseMargin = styled.div`
  position: relative;
  z-index: 2;
  background: rgba(255, 177, 86, 0.65);
  width: 100%;
  height: 25px;
`;
export const BasePadding = styled.div`
  background: rgba(138, 207, 84, 0.5);
  width: 100%;
  height: 75px;
`;

export const InterjectedElement = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--font-family-mono);
  color: var(--color-text);

  &:before,
  &:after {
    content: '';
    flex: 1;
    height: 2px;
    background: var(--color-text);
  }

  &:before {
    margin-right: 8px;
  }
  &:after {
    margin-left: 8px;
  }
`;
